import { useMutation } from '@apollo/client/react';
import { CREATE_DOCUMENT } from '../queries/CreateDocument';

import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

export function useCreateDocument() {
  const context: LoggerContextProps = {
    action: 'createDocument',
  };
  const [createDocumentMutation, { data, loading, error }] = useMutation<{
    createDocument: {
      id: string;
    };
  }>(CREATE_DOCUMENT);

  const createDocument = async (input: any) => {
    try {
      const result = await createDocumentMutation({
        variables: { input },
      });
      return result;
    } catch (error) {
      handleError(error, context, `Failed to create document.`, `Failed to create document:`);
    }
  };

  return {
    createDocument,
    createDocumentMutation,
    data,
    loading,
    error,
  };
}
